import '~/js/libs/jquery.waypoint';
import '~/js/libs/sticky';

// Variable Declaration
const menu = document.getElementById('nav');
const isFixedNav = menu.classList.contains('fixed-nav');

// Internals Variables
const internals = {
    options: {
        element: menu,
        offset: 50,
        stuckClass: 'stuck'
    }
};

// Sticky Nav
if (!isFixedNav) {
    new window.Waypoint.Sticky(internals.options);
}
